class cOptionsGeneral {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elSaveGeneralOptionsBtn = $('#save-general-options-btn');
        this.elEditGeneralOptionsForm = $('#edit-general-options-form');
        elSaveGeneralOptionsBtn.click(function (e) { return self.onEditGeneralOptionsBtnClick(this, e); });
    }
    onEditGeneralOptionsBtnClick(btn, e) {
        if (!$(this.elEditGeneralOptionsForm).find('*[name="contactemail"]').val()) {
            return notify.error("Please specify a contact email address");
        }
        $(btn).button('loading');
        $(this.elEditGeneralOptionsForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updategeneral',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
}
